<template>
  <div class="register-player">
    <div  class="ensure" style="
    font-size: 12px;
    color: green;
    padding: 10px;
    text-align: center;
"> Ensure you have a stable internet connection </div>

    <label :for="`input-${label}-id`">{{ label }}</label>
    <input
      class="input"
      :id="`input-${label}-id`"
      type="number"
      v-model.trim="GameId"
      :placeholder="placeholder"
      @keydown.enter="validateInput"
      autocomplete="off"
    />
    <input
            class="input"
            id="input-phone-id"
            type="text"
            v-model.trim="playerName"
            placeholder="Nickname"
            @keydown.enter="validateInput"
            autocomplete="off"
    />
    <n-button
      @click.native="validateInput"
      :title="buttonTitle"
      :is-loading="isLoading"
    />
    <p class="error-message" v-if="error">{{ error }}</p>
  </div>
</template>

<script>
import Button from "@/components/general/Button";
export default {
  components: {
    "n-button": Button
  },
  data() {
    return {
      disabled:true,
      label: "Enter Game ID and Nickname",
      placeholder: "Game ID",
      playerName: null,
      GameId:null,
      playerPhone:null,
      buttonTitle: "Join Game",
      error: false,
      phoneno:/^0(7(?:(?:[129][0-9])|(?:0[0-8])|(4[0-1]))[0-9]{6})$/
    };
  },
  mounted()
  {
    this.playerPhone =this.playerphone;
    this.playerName = this.playername;
    if (this.playername === '')
    {
      this.disabled=false;
    }
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
    playername()
    {
      return this.$store.state.scores.playerOne.name;
    },
    playerphone()
    {
      return this.$store.state.scores.playerOne.phone;
    }
  },
  watch: {
    playerName() {
      if (this.error) {
        this.error = false;
        this.$emit("error", false);
      }
    }
  },
  methods: {
    validateInput() {
      // const name = this.playerName;
      // const gameId = this.GameId;
      //let phoneno = /^0(7(?:(?:[129][0-9])|(?:0[0-8])|(4[0-1]))[0-9]{6})$/;
      // if (name !== '' && gameId !== '' && !this.isLoading) {
          this.registerNewPlayer();
      //   }else
      // {
      //   this.$store.commit('flushMessages', 'Please fill in all details to proceed!');
      // }

    },
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
    },
    setCookie(name,value,days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    },
    getRandomString() {
      var length=12;
      var chars= '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';

      var result = '';
      for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
      return result;
    },
    registerNewPlayer() {
      let vm = this;
      var xIDS=this.getCookie('xIDS');
      if(xIDS==undefined || xIDS ==""){
        xIDS=this.getRandomString();
        this.setCookie('xIDS',xIDS,7);
      }
      console.log('here');
      this.$store.dispatch("registerNewPlayer", {'xIDS':xIDS,'name':this.playerName,'trivia_id':this.GameId});
      this.$store.commit('pauseGame');
      this.$store.commit('playerClickedCard',false);
      this.$store.commit('setResults',false);
    }
  }
};
</script>
<style>
  ::placeholder {
    color: rgba(0, 0, 0, 0.38)!important;
    opacity: 1!important; /* Firefox */
  }

  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: rgba(0, 0, 0, 0.38)!important;
  }

  ::-ms-input-placeholder { /* Microsoft Edge */
    color: rgba(0, 0, 0, 0.38)!important;
  }
</style>
<style lang="sass" scoped>

.register-player
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  text-align: center

.input
  margin: 1rem
  color: inherit
  font: inherit
  outline: 0
  background: 0
  border: 1px solid $color-gray
  -webkit-appearance:none
  border-radius: $border-radius
  padding: 0.5rem 1rem
  text-align: center
  font-size: $font-size-large
  font-weight: 600
  max-width: 18rem
  width: 100%

.input::placeholder
  color: $color-gray--darker

.error-message
  margin-top: 0.5rem
  max-width: 250px
</style>
